import React from 'react';
import Snackbar from '@material-ui/core/Snackbar'
import SnackbarContent from '@material-ui/core/SnackbarContent'
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles'
import Slide from '@material-ui/core/Slide';

function TransitionUp(props) {
  return <Slide {...props} direction="up" />;
}

const styles = theme => ({


  success: {
    backgroundColor: "#417505",
  },
  error: {
    backgroundColor: "#B00020",
  },
  info: {
    backgroundColor: "#255A8D",
  },
  warning: {
    backgroundColor: "#CA6D2E",
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'pre-line'
  },
});

const stylesRoot= theme =>({
  root: {
    [theme.breakpoints.up('md')]: {
      minWidth: 600,
      maxWidth: 600
    },
  },
})

class StyledSnackBarContent extends React.PureComponent {

  render() {
    const { classes, className, message, variant, open, ...other } = this.props;

    return (
      <SnackbarContent
        className={classNames(classes[variant], className)}
        aria-describedby="instalevel-snackbar"

        message={
          <span id="instalevel-snackbar" className={classes.message}>
          {message}
          </span>
        }
        {...other}
      />
    );
  }
}

const CustomSnackBarContent = withStyles(styles)(StyledSnackBarContent);

class CustomSnackBar extends React.Component {
  handleClose(event,reason) {
    // console.log(reason)
    this.props.handleClose()
  }

  render() {
    const { variant, message, open, classes } = this.props
    return (
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={open}
        TransitionComponent={TransitionUp}
        autoHideDuration={3000}
        onClose={this.handleClose.bind(this)}
      >
        <CustomSnackBarContent
          variant={variant}
          message={message}
          className={classes.root}
        />
      </Snackbar>

    )
  }
}
export default withStyles(stylesRoot)(CustomSnackBar)



// WEBPACK FOOTER //
// ./src/js/components/Mui/CustomSnackBar.js